// @ts-nocheck FIXME
import { useLegacyLabContext } from '@contexts/LegacyLabContext';
import Utils from '@legacy-components/components/DynamicUtils';
import { HeaderConsumer } from '@legacy-components/context/HeaderContext';
import UserPhoto from '@legacy-components/react/V5/Common/UserPhoto';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';

const User = (props) => {
  const lab = useLegacyLabContext();

  const generateNavOptions = () => {
    const navOptions = [];

    navOptions.push({
      caption: 'Favorites',
      link: `${process.env.REACT_APP_LAB_URL}/browse/favorites`,
      external: true,
    });

    navOptions.push({
      caption: 'Log Out',
      link: '/logout',
      external: true,
    });
    return navOptions;
  };

  return (
    <Dropdown
      navKey={props.viewType === 'mobile' ? 'mobile-user' : 'user'}
      user={props.user}
      navOptions={generateNavOptions()}
      className="header__dropdown-container--user"
    >
      <UserPhoto
        src={props.user.photo}
        userId={props.user.id}
        firstName={props.user.first_name}
        lastName={props.user.last_name}
        diameter={40}
        className="header__user"
      />
    </Dropdown>
  );
};

const ConnectedUser = (props) => (
  <HeaderConsumer>
    {({ user }) => <User {...props} user={user} />}
  </HeaderConsumer>
);

export default ConnectedUser;

User.propTypes = {
  viewType: PropTypes.string,
  user: PropTypes.object.isRequired,
};
